<div class="ui-messages" *ngIf="messages.length > 0">
  <ng-container *ngFor="let message of messages">
      <div class="ui-message" [ngClass]="message.level">
          <mat-icon>{{message.icon}}</mat-icon>
          <span>{{message.text}}</span>
      </div>
  </ng-container>
</div>